import axios from 'axios';

export default {
  historyBudget(params = {}) {
    return axios.get('/v1/logs/budget', { params });
  },
  historyApproval(params = {}) {
    return axios.get('/v1/logs/approval', { params });
  },
  historySpending(params = {}) {
    return axios.get('/v1/logs/spending', { params });
  },
  detailSpending(id) {
    return axios.get(`/v1/logs/spending/${id}`);
  },
  createGimmick(data) {
    return axios.post('/v1/roi/gimmick', data);
  },
  getRoi(params = {}) {
    return axios.get('/v1/roi', { params });
  },
  createCrm(data) {
    return axios.post('/v1/roi/crm', data);
  }
};
